import React from 'react';
import { TextField, Box } from '@material-ui/core';

interface MyTextFieldProps {
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onEnterPress: () => void;
  text: string;
  placeholder: string;
  warning: string;
  isError: boolean;
}

export const MyTextField = (props: MyTextFieldProps) => {
  const { onChange, onEnterPress, text, placeholder, warning, isError } = props;

  return (
    <>
      <TextField
        placeholder={placeholder}
        fullWidth
        variant="outlined"
        value={text}
        onChange={onChange}
        error={isError}
        margin="dense"
        onKeyPress={(ev) => {
          if (ev.key === 'Enter') {
            ev.preventDefault();
            onEnterPress();
          }
        }}
      />
      {isError && (
        <Box color="red" ml={2}>
          {warning}
        </Box>
      )}
    </>
  );
};
